import { render, staticRenderFns } from "./Sinos.vue?vue&type=template&id=7b23f972&"
import script from "./Sinos.vue?vue&type=script&lang=js&"
export * from "./Sinos.vue?vue&type=script&lang=js&"
import style0 from "./Sinos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports